import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

// Classic Parallax

export function parallax(image: HTMLElement) {
  let mm = gsap.matchMedia()

  mm.add('(min-width: 992px)', () => {
    if (image.parentElement) {
      gsap.set(image.parentElement, { overflow: 'hidden' })
      gsap.set(image, { yPercent: -15 })

      gsap.to(
        image,
        // {
        //  // y: -(image.offsetHeight - image.parentElement.offsetHeight)
        //   // yPercent: -15
        // },
        {
          scrollTrigger: {
            trigger: image.parentElement,
            scrub: true,
            start: 'top center',
            end: 'bottom center',
            invalidateOnRefresh: true
            //  markers: true
          },
          yPercent: 0,
          ease: 'none'
        }
      )
    }
  })
}
